import useCloseRsuiteDatePickersOnOutsideClick from "../../hooks/useCloseRsuiteDatePickersOnOutsideClick";

/**
 * App-level listener so all rsuite date / date-range calendars close on
 * outside click without waiting for the open animation to finish.
 */
export default function CloseRsuiteDatePickersOnOutsideClick() {
  useCloseRsuiteDatePickersOnOutsideClick();
  return null;
}
